'use strict';

// Slide to section links
$('.js_link').on('click', function(e) {
  e.preventDefault();

  let fromTopOffset = $(this).data('offset');
  if (!fromTopOffset) {
    fromTopOffset = 0;
  }

  const target = $(this).attr('href');
  const offset = $(target).offset().top - fromTopOffset;

  $('html,body').animate({scrollTop: offset}, 700);

  return 0;
});

// Header (SP)
{
  const spHeader = {
    el: {
      $header: $('.js_header-sp .header-home-sp'),
      $headerLogo: $('.js_header-sp-logo')
    },

    init() {
      this.scrollHandler();
    },

    scrollHandler() {
      const _this = this;

      $('.main--home').waypoint({
        offset: 60,
        handler() {
          _this.showHeader();
          _this.showHeaderLogo();
        }
      });
    },

    showHeader() {
      this.el.$header.toggleClass('active');
    },

    showHeaderLogo() {
      this.el.$headerLogo.addClass('active');
    }
  };

  if ($('.js_header-sp').length) {
    spHeader.init();
  }
}

// Hamburger menu (SP)
{
  const spMenu = {
    el: {
      $menu: $('.js_nav-sp'),
      $openBtn: $('.js_header-sp-open'),
      $closeBtn: $('.js_header-sp-close')
    },

    init() {
      this.openHandler();
      this.closeHandler();
    },

    openHandler() {
      const _this = this;

      this.el.$openBtn.on('click', function(e) {
        e.preventDefault();
        _this.openMenu();
        return 0;
      });
    },

    closeHandler() {
      const _this = this;

      this.el.$closeBtn.on('click', function(e) {
        e.preventDefault();
        _this.closeMenu();
        return 0;
      });
    },

    openMenu() {
      this.el.$menu.addClass('active');
    },

    closeMenu() {
      this.el.$menu.removeClass('active');
    }
  };

  if ($('.js_nav-sp').length) {
    spMenu.init();
  }
}

// Home page slider
{
  const topSlider = {
    el: {
      $slider: $('.js_top-slider'),
      sliderBtnNextClass: '.js_top-slider-next',
      sliderBtnPrevClass: '.js_top-slider-prev'
    },

    init() {
      this.initiateSlick();
    },

    initiateSlick() {
      const _this = this;

      _this.el.$slider.slick({
        swipe: false,
        infinite: true,
        // speed: 800,
        speed: 1600,
        autoplay: true,
        autoplaySpeed: 5000,
        fade: true,
        // cssEase: 'ease-in-out',
        cssEase: 'ease',
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        nextArrow: $(_this.el.sliderBtnNextClass),
        prevArrow: $(_this.el.sliderBtnPrevClass),
        dots: true,
        dotsClass: 'slider__dots'
      });
    }
  };

  if ($('.js_top-slider').length) {
    topSlider.init();
  }
}

// Shop guide slider
{
  const shopsSlider = {
    el: {
      $slider: $('.js_shops-slider'),
      sliderBtnNextClass: '.js_shops-slider-next',
      sliderBtnPrevClass: '.js_shops-slider-prev'
    },

    init() {
      this.initiateSlick();
    },

    initiateSlick() {
      const _this = this;

      _this.el.$slider.each(function() {
        const $slider = $(this);

        $slider.slick({
          swipe: false,
          infinite: true,
          slidesToShow: 3,
          slidesToScroll: 1,
          nextArrow: $slider.parent().find(_this.el.sliderBtnNextClass),
          prevArrow: $slider.parent().find(_this.el.sliderBtnPrevClass)
        });
      });
    }
  };

  if ($('.js_shops-slider').length) {
    shopsSlider.init();
  }
}

// Access accordion
{
  const accessAccordion = {
    el: {
      acrClass: '.js_access-acr',
      btnClass: '.js_access-acr-btn',
      contentClass: '.js_access-acr-content'
    },

    init() {
      this.clickHandler();
    },

    clickHandler() {
      const _this = this;

      $(_this.el.acrClass)
        .find(_this.el.btnClass)
        .on('click', function() {
          const $btn = $(this);
          const $content = $btn.parent(_this.el.acrClass).find(_this.el.contentClass);

          _this.toggleActive($btn);
          _this.toggleContent($content);
        });
    },

    toggleContent($content) {
      $content.slideToggle(300);
    },

    toggleActive($btn) {
      $btn.toggleClass('active');
    }
  };

  if ($('.js_access-acr').length) {
    accessAccordion.init();
  }
}

// Shoplist
{
  const shopList = {
    conf: {
      csvFoodDrinks: '/assets/csv/shoplists/food-drinks.csv',
      csvShopsServices: '/assets/csv/shoplists/shops-services.csv',
      csvHotelsInns: '/assets/csv/shoplists/hotels-inns.csv'
    },

    el: {
      $listFoodDrinks: $('.js_shoplist-food-drinks'),
      $listShopsServices: $('.js_shoplist-shops-services'),
      $listHotelsInns: $('.js_shoplist-hotels-inns')
    },

    init() {
      this.disableScrollRestore();
      this.ajax(this.conf.csvFoodDrinks, this.el.$listFoodDrinks);
      this.ajax(this.conf.csvShopsServices, this.el.$listShopsServices);
      this.ajax(this.conf.csvHotelsInns, this.el.$listHotelsInns);
      this.urlHandler();
    },

    ajax(path, $container) {
      const _this = this;

      $.get(path, function(data) {
        const shopListObject = $.csv.toObjects(data);

        const html = _this.generateHTML(shopListObject);

        _this.printHTML(html, $container);
      });
    },

    generateHTML(shopListObject) {
      let html = '';
      let newSubSection = true;
      let currentSubSection = '';

      Object.keys(shopListObject).forEach((key) => {
        // console.log(key);
        // console.log(shopListObject[key]);
        const shopObject = shopListObject[key];

        if (
          (currentSubSection !== shopObject['中カテゴリー'] && shopObject['中カテゴリー']) ||
          key == 0
        ) {
          newSubSection = true;
        } else {
          newSubSection = false;
        }

        if (newSubSection) {
          if (shopObject['中カテゴリー']) {
            if (key !== 0) {
              html += '</div> <!-- end of .shoplist__cards -->';
            }
            if (currentSubSection !== shopObject['中カテゴリー']) {
              html += `<h3 class="shoplist__section__subheading">${shopObject['中カテゴリー']}</h3>`;
              currentSubSection = shopObject['中カテゴリー'];
            }
          }
          html += '<div class="shoplist__cards">';
        }

        html += '<div class="shoplist__card">';

        // Card top
        if (shopObject['店名'])
          html += `<h4 class="shoplist__card__heading">${shopObject['店名']}</h4>`;
        if (shopObject['店紹介'])
          html += `<p class="shoplist__card__descr">${shopObject['店紹介']}</p>`;

        // Card info section
        html += '<div class="shoplist__card__info"><table>';

        if (shopObject['住所']) html += `<tr><td>住所</td><td>${shopObject['住所']}</td></tr>`;
        if (shopObject.TEL) html += `<tr><td>電話</td><td>${shopObject.TEL}</td></tr>`;
        if (shopObject.Email)
          html += `<tr><td>メール</td><td><a href="mailto:${shopObject.Email}" class="link" target="_blank">${shopObject.Email}</a></td></tr>`;
        if (shopObject['営業時間'])
          html += `<tr><td>営業時間</td><td>${shopObject['営業時間']}</td></tr>`;
        if (shopObject['定休日'])
          html += `<tr><td>定休日</td><td>${shopObject['定休日']}</td></tr>`;
        if (shopObject.Web) {
          const webLinks = shopObject.Web.trim().split(/\s+/);

          html += `<tr><td>WEB</td><td>`;
          webLinks.forEach((url) => {
            html += `<a href="${url}" class="link" target="_blank">${url}</a><br>`;
          });
          html += `</td></tr>`;
        }
        if (shopObject.Facebook || shopObject.Twitter || shopObject.Instagram) {
          html += '<tr><td>SNS</td><td class="shoplist__card__sns">';

          if (shopObject.Facebook) {
            const twLinks = shopObject.Facebook.trim().split(/\s+/);

            if (twLinks.length > 1) {
              twLinks.forEach((item) => {
                const urlArray = item.split('：');
                html += `<br><a class="link" href="${urlArray[1]}" target="_blank">Facebook (${urlArray[0]})</a>`;
              });
            } else {
              html += `<a class="link" href="${shopObject.Facebook}" target="_blank">Facebook</a>`;
            }
          }
          if (shopObject.Twitter) {
            const twLinks = shopObject.Twitter.trim().split(/\s+/);

            if (twLinks.length > 1) {
              twLinks.forEach((item) => {
                const urlArray = item.split('：');
                html += `<br><a class="link" href="${urlArray[1]}" target="_blank">Twitter (${urlArray[0]})</a>`;
              });
            } else {
              html += `<a class="link" href="${shopObject.Twitter}" target="_blank">Twitter</a>`;
            }
          }
          if (shopObject.Instagram) {
            const igLinks = shopObject.Instagram.trim().split(/\s+/);

            if (igLinks.length > 1) {
              igLinks.forEach((item) => {
                const urlArray = item.split('：');
                html += `<br><a class="link" href="${urlArray[1]}" target="_blank">Instagram (${urlArray[0]})</a>`;
              });
            } else {
              html += `<a class="link" href="${shopObject.Instagram}" target="_blank">Instagram</a>`;
            }
          }

          html += '</td></tr>';
        }
        if (shopObject['TAX FREE']) html += `<tr><td>TAX FREE</td></tr>`;

        html += '</table></div> <!-- end of .shoplist__info -->';

        if (shopObject['取り扱いブランド'])
          html += `<div class="shoplist__card__bottom"><p class="shoplist__card__bottom__title">取り扱いブランド一覧</p><p class="shoplist__card__bottom__text">${shopObject['取り扱いブランド']}</p></div>`;

        html += '</div> <!-- end of .shoplist__card -->';
      });

      html += '</div> <!-- end of .shoplist__cards -->';

      return html;
    },

    printHTML(html, $container) {
      const _this = this;
      $container.html(html);
    },

    urlHandler() {
      if (window.location.hash) {
        const target = window.location.hash;
        setTimeout(function() {
          const offset = $(target).offset().top;
          $('html,body').animate({scrollTop: offset}, 0);
        }, 1000);
      }
    },

    disableScrollRestore() {
      window.history.scrollRestoration = 'manual';
    }
  };

  if ($('.js_shoplist-food-drinks').length) {
    shopList.init();
  }
}

// Truncate text
{
  const textTruncation = {
    el: {
      $text: $('.js_truncate')
    },

    init() {
      const _this = this;

      $(window).on('load', function() {
        _this.initializeTruncation();
      });
    },

    initializeTruncation() {
      $('.js_truncate').each(function() {
        const $text = $(this);
        const numLines = $text.data('lines');

        $text.trunk8({
          fill: '&hellip;',
          lines: numLines,
          tooltip: false
        });
      });
    }
  };

  if ($('.js_truncate').length) {
    textTruncation.init();
  }
}

// Equal cols
{
  const equalCols = {
    el: {
      containerClass: '.js_equal-cols',
      sectionClass: '.js_equal-cols-section'
    },

    init() {
      this.setEqualCols();
    },

    setEqualCols() {
      const $section = $(this.el.sectionClass);
      const numCols = $section.first().find('p').length;

      const setWidth = function(index) {
        let maxWidth = 0;

        $section.each(function() {
          const colWidth = $(this)
            .find(`p:eq(${index})`)
            .width();

          if (colWidth > maxWidth) {
            maxWidth = colWidth;
          }
        });

        $section.each(function() {
          $(this)
            .find(`p:eq(${index})`)
            .width(maxWidth);
        });
      };

      for (let i = 0; i < numCols; i += 1) {
        setWidth(i);
      }
    }
  };

  if ($('.js_equal-cols').length) {
    equalCols.init();
  }
}

// Go to top button
{
  const goToTop = {
    el: {
      $btn: $('.page--sub .js_goto-top'),
      $triggerEl: $('.main')
    },

    init() {
      this.scrollHandler();
    },

    scrollHandler() {
      const _this = this;

      _this.el.$triggerEl.waypoint({
        handler() {
          _this.showBtn();
        }
      });
    },

    showBtn() {
      this.el.$btn.stop().fadeToggle(400);
    }
  };

  if ($('.page--sub .js_goto-top').length) {
    goToTop.init();
  }
}
